import { Flex } from "@chakra-ui/react"

import Icon from "components/UI/atoms/Icon"
import Heading from "components/UI/atoms/Heading"
import { IEmployee } from "api/querries/useGetEmployees"

interface IActions {
  handleEditClick: (e:React.MouseEvent, data: IEmployee) => void,
  handleDeleteClick: (data: IEmployee) => void,
}

export const getActions: any = ({ T, handleEditClick, handleDeleteClick}: any) => {

  return [
    {
      key: "edit",
      render: (data: any) => (
        <Flex gap={"10px"} alignItems={"flex-start"} justifyContent={"center"}>
          <Icon name="edit" iconStyles={{ fill: "#046CEC" }} />
          <Heading title={T("actions.edit")} variant="regular" size="sm" />
        </Flex>
      ),
      onClick: (data: any) => handleEditClick(data)
    },
    {
      key: "delete",
      render: (data: any) => (
        <Flex gap={"10px"} alignItems={"flex-start"} justifyContent={"center"}>
          <Icon name="delete" iconStyles={{ fill: "#046CEC" }} />
          <Heading title={T("actions.delete")} variant="regular" size="sm" />
        </Flex>
      ),
      onClick: (data: any) => handleDeleteClick(data)
    },
  ]
}
